import rosterFiltersUrl from './rosterFiltersComponent.html';

class RosterFiltersCtrl {
  constructor(RosterService, DayPartsService, ShiftUtils, $q) {
    'ngInject';

    Object.assign(this, { RosterService, DayPartsService, ShiftUtils, $q });
  }

  async $onInit() {
    await this.$q.all([this.DayPartsService.loadData(), this.ShiftUtils.loadAsync()]);

    this.tagsForFilter = this.ShiftUtils.getTagsFilterOptions(this.RosterService.tags);
    this.groupsForFilter = this.ShiftUtils.getGroupsFilterOptions(this.RosterService.userGroups);
    this.dayPartsForFilter = this.ShiftUtils.getDayPartsFilterOptions(
      this.DayPartsService.dayParts
    );
  }

  toggleFilter(...args) {
    this.RosterService.toggleFilter(...args);
    this.changeFilters();
  }

  shouldHideFilter(options) {
    return !options || options.length < 2;
  }

  clearAllFilters() {
    this.RosterService.clearAllFilters();
    this.changeFilters();
  }
}

export default {
  templateUrl: rosterFiltersUrl,
  controller: RosterFiltersCtrl,
  controllerAs: 'ctrl',
  bindings: {
    changeFilters: '&',
    hasEvents: '<',
  },
};
